/**
 * Known documents for 書類交付.
 * Add a title here when a new PDF should be recognized. Field reading for a
 * title that has no extractor yet stays incomplete until that step is built.
 */

export type DocumentTypeId =
  | 'withholding-slip'
  | 'standard-remuneration'
  | 'standard-bonus';

export interface DocumentTypeDefinition {
  id: DocumentTypeId;
  /** Value shown in 書類の種類. */
  label: string;
  /** Matched against the PDF text with spaces removed. Longer titles win. */
  titles: string[];
  /** 改定年月 is part of this document. */
  usesRevisionMonth: boolean;
}

export const DOCUMENT_TYPES: DocumentTypeDefinition[] = [
  {
    id: 'withholding-slip',
    label: '給与所得の源泉徴収票',
    titles: ['給与所得の源泉徴収票'],
    usesRevisionMonth: false,
  },
  {
    id: 'standard-remuneration',
    label: '基準報酬決定通知書',
    titles: ['基準報酬決定通知書'],
    usesRevisionMonth: true,
  },
  {
    id: 'standard-bonus',
    label: '基準賞与額決定通知書',
    titles: ['基準賞与額決定通知書'],
    usesRevisionMonth: false,
  },
];

export function matchDocumentType(compactText: string): DocumentTypeDefinition | undefined {
  const hits = DOCUMENT_TYPES.filter((definition) =>
    definition.titles.some((title) => compactText.includes(title.replace(/\s/g, '')))
  );
  hits.sort((a, b) => Math.max(...b.titles.map((title) => title.length)) - Math.max(...a.titles.map((title) => title.length)));
  return hits[0];
}
